import { render, staticRenderFns } from "./OimoWorld.vue?vue&type=template&id=5d51e327&"
import script from "./OimoWorld.vue?vue&type=script&lang=js&"
export * from "./OimoWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports